export const getExtension = (filename) => {
    let parts = filename.split(".");
    return parts[parts.length - 1];
  };